<template>
    <div class="mask" v-if="dataVal.flag">
        <div class="mask-content">
            <div class="mask-content-header">
                <img src="@/assets/images/icon/warning.png" alt="" srcset="">
                <div>温馨提示</div>
            </div>
            <div class="mask-content-body">
                <div class="mask-content-body-text">{{ dataVal.text }}</div>
                <div class="inner-date" v-if="dataVal.type == '3333'">
                    <el-date-picker v-model="expectbirths" type="daterange" range-separator="~"
                        start-placeholder="活动开始时间" end-placeholder="活动结束时间" value-format="timestamp"
                        popper-class="groupselsect" append-to-body clearable>
                    </el-date-picker>
                </div>
                <div class="mask-content-footer">
                    <div @click="handleRefund">取消</div>
                    <div @click="handleSubmit">确认</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AddGroup",
    props: ['dataVal'],
    data() {
        return {
            expectbirths: [],

            fromData: {
                stime: '',
                etime: '',
                activity_id: ''
            }
        };
    },
    mounted() {
    },
    methods: {
        //取消弹窗
        handleRefund() {
            let data = {
                flag: false,
                submitFlag: false
            }
            this.$emit("tipCall", data);
        },
        handleSubmit() {
            let data = {
                flag: false,//弹窗是否显示
                submitFlag: true,//是否调用接口
                data: this.fromData
            }
            this.$emit("tipCall", data);
        },
    },
    watch: {
        dataVal: {
            handler(val) {
                console.log('tipobj', val)
                this.expectbirths = []
                if (val.type == '3333') {
                    this.fromData.activity_id = val.id
                }
            },
            deep: true
        },
        expectbirths: {
            handler(newVal, oldVal) {
                if (newVal && newVal.length == 2) {
                    this.fromData.stime = Number(newVal[0]) / 1000
                    this.fromData.etime = Number(newVal[1]) / 1000
                } else {
                    this.fromData.stime = ''
                    this.fromData.etime = ''
                }
            },
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped>
.mask {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;

    .mask-content {
        border-radius: 10px;
        box-shadow: 1px 1px 10px 0 rgba(0, 0, 0, 0.2);
        background: #FFF;
        overflow: hidden;
        position: fixed;
        padding: 24px 32px 32px 32px;

        .mask-content-header {
            display: flex;
            align-items: center;

            img {
                width: 20px;
                height: 20px;
            }

            div {
                color: #1D2129;
                font-size: 16px;
                font-weight: 600;
                margin-left: 8px;
            }
        }

        .mask-content-body {
            width: 336px;
            background-color: #FFF;
            margin-top: 16px;

            .mask-content-body-text {
                width: 100%;
                color: #1D2129;
                font-size: 14px;
            }

            .inner-date {
                margin-top: 20px;
            }

            .mask-content-footer {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 24px;

                div {
                    width: 60px;
                    height: 32px;
                    color: #fff;
                    font-size: 14px;
                    border-radius: 2px;
                    background: #86909C;
                    @include flex-center(center, center);
                    cursor: pointer;

                    &:nth-child(2) {
                        border-radius: 2px;
                        color: #fff;
                        background: #C12E30;
                        margin-left: 8px;
                    }
                }
            }
        }
    }
}
</style>